module.exports = __webpack_public_path__ + "static/media/kiwiandkorv.8fafc7c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/uncomp/kiwiandkorv.png
// module id = 55
// module chunks = 0